<div appTheme>
    <app-alerts></app-alerts>

    <div class="split-container">

        <!-------------------------->
        <!-- Hamburger Menu -->
        <div class="nav-bar hamburger-menu" *ngIf="isHamburgerMenuExpanded && isMobileWidth"
            (blur)="setIsHamburgerMenuExpanded($event, false)">
            <div class="box-large" id="LocatonLink" routerLinkActive="selected" routerLink="locations"
                (click)="onHamburgerMenuItemSelected()">
                <div class="box-large-text">
                    <i class="fa fa-map-marker ss-fa-icon"></i>
                    <div class="text-box">
                        <span class="text">Location</span>
                    </div>
                </div>
            </div>

            <!-- Irrigation -->
            <div routerLinkActive="active-link" [class.dimmed]="!location || locationManager.isLoadingInformation"
                pTooltip="{{tooltipText}}" tooltipPosition="{{tooltipPlacement}}" showDelay="500">
                <div class="box-large" id="IrrigationLink" routerLinkActive="selected" routerLink="irrigation/main">
                    <div class="box-large-text">
                        <i class="fa fa-tint ss-fa-icon"></i>
                        <div class="text-box">
                            <span class="text">Irrigation</span>
                        </div>
                    </div>
                    <span class="chevron"></span>
                </div>
                <div class="sub-box-container" routerLinkActive="selected">
                    <a class="sub-box" id="DashboardLink" routerLinkActive="selected" routerLink="irrigation/main"
                        (click)="onHamburgerMenuItemSelected()">
                        <i class="fa-stack ss-fa-stacked">
                            <i class="fa fa-circle-thin fa-stack-2x"></i>
                            <i class="fa fa-tint fa-stack-1x"></i>
                        </i>
                        <span class="text">Dashboard</span>
                    </a>
                    <a class="sub-box" id="ProgramsLink" routerLinkActive="selected" routerLink="irrigation/schedules"
                        (click)="onHamburgerMenuItemSelected()">
                        <i class="fa fa-calendar ss-fa-icon"></i>
                        <span class="text">Programs</span>
                    </a>
                    <a class="sub-box" id="StationsLink" routerLinkActive="selected" routerLink="irrigation/zones"
                        (click)="onHamburgerMenuItemSelected()">
                        <i class="ss-fa-icon icon-irrigation-stations fontello-irrigation-icons"></i>
                        <span class="text">Stations</span>
                    </a>
                    <a class="sub-box" id="ControllersLink" routerLinkActive="selected"
                        routerLink="irrigation/controllers" (click)="onHamburgerMenuItemSelected()">
                        <i class="ss-fa-icon icon-irrigation-controller fontello-irrigation-icons"></i>
                        <span class="text">Controllers</span>
                    </a>
                </div>
            </div>

            <!-- Lighting -->
            <div routerLinkActive="active-link" [class.dimmed]="!location || locationManager.isLoadingInformation"
                pTooltip="{{tooltipText}}" tooltipPosition="{{tooltipPlacement}}" showDelay="500">
                <div class="box-large" id="LightingLink" routerLinkActive="selected" routerLink="lighting/scenes">
                    <div class="box-large-text">
                        <i class="icon-lighting lighting-icons"></i>
                        <div class="text-box">
                            <span class="text">Lighting / Aux.</span>
                        </div>
                    </div>
                    <span class="chevron"></span>
                </div>
                <div class="sub-box-container" routerLinkActive="selected">
                    <a class="sub-box-lighting" id="ScenesLink" routerLinkActive="selected" routerLink="lighting/scenes"
                        (click)="onHamburgerMenuItemSelected()">
                        <i class="ss-fa-icon icon-lighting-scenes lighting-icons" pTooltip="Lighting Dashboard"
                            tooltipPosition="{{tooltipPosition}}" showDelay="500"></i>
                        <span class="text">Scenes</span>
                    </a>
                    <a class="sub-box-lighting" id="ThemesLink" routerLinkActive="selected" routerLink="lighting/themes"
                        (click)="onHamburgerMenuItemSelected()">
                        <i class="ss-fa-icon icon-lighting-scenes lighting-icons" pTooltip="Lighting Dashboard"
                            tooltipPosition="{{tooltipPosition}}" showDelay="500"></i>
                        <span class="text">Themes</span>
                    </a>
                    <a class="sub-box-lighting" id="DevicesLink" routerLinkActive="selected"
                        routerLink="lighting/lights" (click)="onHamburgerMenuItemSelected()">
                        <i class="fa fa-lightbulb-o ss-fa-icon"></i>
                        <span class="text">{{ Strings.Devices }}</span>
                    </a>
                </div>
            </div>

            <a class="box" id="SignOutLink" (click)="onSignOut()">
                <i class="fa fa-power-off ss-fa-icon"></i>
                <span class="text sign-out-hamburger-menu-text">Sign Out</span>
            </a>
        </div>
        <!-------------------------->
        <!-------------------------->

        <!-- -------------------- -->
        <!-- Sidebar -->
        <div class="column nav-bar" *ngIf="!isMobileWidth" [ngClass]="{'narrow' : isNavbarNarrow}">
            <div class="arrow-box" (click)="toggleMenuWidth()">
                <div *ngIf="!isNavbarLockedFromExpanding" class="arrow-box-icon"></div>
            </div>

            <div class="box-large" id="LocatonLink" routerLinkActive="selected" routerLink="/dashboard/locations">
                <div class="box-large-text">
                    <i class="fa fa-map-marker ss-fa-icon" pTooltip="Location" tooltipPosition="{{tooltipPosition}}"
                        showDelay="500"></i>
                    <div class="text-box">
                        <span class="text">Locations</span>
                    </div>
                </div>
            </div>

            <!-- Irrigation -->
            <div routerLinkActive="active-link" [class.dimmed]="!location || locationManager.isLoadingInformation"
                pTooltip="{{tooltipText}}" tooltipPosition="{{tooltipPlacement}}" showDelay="500">
                <div class="box-large" id="IrrigationLink" routerLinkActive="selected"
                    routerLink="/dashboard/{{locationId}}/irrigation/main">
                    <div class="box-large-text">
                        <i class="fa fa-tint ss-fa-icon" pTooltip="Irrigation" tooltipPosition="{{tooltipPosition}}"
                            showDelay="500"></i>
                        <div class="text-box">
                            <span class="text">Irrigation</span>
                        </div>
                    </div>
                    <span class="chevron"></span>
                </div>
                <div class="sub-box-container" routerLinkActive="selected">
                    <a class="sub-box" id="DashboardLink" routerLinkActive="selected" routerLink="irrigation/main">
                        <i class="fa-stack ss-fa-stacked" showDelay="500" pTooltip="Irrigation Dashboard"
                            tooltipPosition="{{tooltipPosition}}">
                            <i class="fa fa-circle-thin fa-stack-2x"></i>
                            <i class="fa fa-tint fa-stack-1x"></i>
                        </i>
                        <span class="text">Dashboard</span>
                    </a>
                    <a class="sub-box" id="ProgramsLink" pTooltip="{{tooltipTextIrrigation}}"
                        tooltipPosition="{{tooltipIrrigationPlacement}}" [class.dimmed]="!isControllers"
                        routerLinkActive="selected" routerLink="irrigation/schedules">
                        <i class="fa fa-calendar ss-fa-icon" pTooltip="Programs" tooltipPosition="{{tooltipPosition}}"
                            showDelay="500"></i>
                        <span class="text">Programs</span>
                    </a>
                    <a class="sub-box" id="StationsLink" pTooltip="{{tooltipTextIrrigation}}"
                        tooltipPosition="{{tooltipIrrigationPlacement}}" [class.dimmed]="!isControllers"
                        routerLinkActive="selected" routerLink="irrigation/zones">
                        <i class="ss-fa-icon icon-irrigation-stations fontello-irrigation-icons"
                            pTooltip="Irrigation Zones" tooltipPosition="{{tooltipPosition}}" showDelay="500"></i>
                        <span class="text">Stations</span>
                    </a>
                    <a class="sub-box" id="ControllersLink" routerLinkActive="selected"
                        routerLink="irrigation/controllers">
                        <i class="ss-fa-icon icon-irrigation-controller fontello-irrigation-icons"
                            pTooltip="Irrigation Controllers" tooltipPosition="{{tooltipPosition}}" showDelay="500"></i>
                        <span class="text">Controllers</span>
                    </a>
                </div>
            </div>

            <!-- Lighting -->
            <div routerLinkActive="active-link" [class.dimmed]="!location || locationManager.isLoadingInformation"
                pTooltip="{{tooltipText}}" tooltipPosition="{{tooltipPlacement}}" showDelay="500">
                <div class="box-large" id="LightingLink" routerLinkActive="selected" routerLink="lighting/scenes">
                    <div class="box-large-text">
                        <i class="icon-lighting lighting-icons" pTooltip="Lighting / Aux."
                            tooltipPosition="{{tooltipPosition}}" showDelay="500"></i>
                        <div class="text-box">
                            <span class="text">Lighting / Aux.</span>
                        </div>
                    </div>
                    <span class="chevron"></span>
                </div>
                <div class="sub-box-container" routerLinkActive="selected">
                    <a class="sub-box-lighting" id="ScenesLink" routerLinkActive="selected"
                        routerLink="lighting/scenes">
                        <i class="ss-fa-icon icon-lighting-scenes lighting-icons" pTooltip="Lighting Dashboard"
                            tooltipPosition="{{tooltipPosition}}" showDelay="500"></i>
                        <span class="text">Scenes</span>
                    </a>
                    <a class="sub-box-lighting" id="ThemesLink" routerLinkActive="selected"
                        routerLink="lighting/themes">
                        <i class="fa fa-cubes ss-fa-icon" pTooltip="Themes" tooltipPosition="{{tooltipPosition}}"
                            showDelay="500"></i>
                        <span class="text">Themes</span>
                    </a>
                    <a class="sub-box-lighting" id="DevicesLink" routerLinkActive="selected"
                        routerLink="lighting/lights">
                        <i class="fa fa-lightbulb-o ss-fa-icon" pTooltip="Lighting Lights"
                            tooltipPosition="{{tooltipPosition}}" showDelay="500"></i>
                        <span class="text">{{ Strings.Devices }}</span>
                    </a>
                </div>
            </div>

            <div class="spacer-box"></div>

        </div>
        <!-------------------------->
        <!-------------------------->

        <div class="main-container scrolling" [ngStyle]="inlineStyle">
            <router-outlet></router-outlet>
        </div>

    </div>
</div>

<p-dialog [(visible)]="displayWhatsNew" [breakpoint]="0" [modal]="true" [appendTo]="'body'" [closable]="true"
    [closeOnEscape]="true" [showHeader]="true" (onHide)="close()" [draggable]="false">

    <p-header>
        {{ Constants.AppName }} - What's New!
    </p-header>

    <app-whats-new></app-whats-new>

</p-dialog>